<template>
  <div class="main" :style="{background:`Url(${setting.bg || '../assets/imgs/bg.png'})`}">

    <div class='mid'>
      <div class="left">
      </div>
      <div class="right">
        <div class="login">
          <img src="../assets/3.png" alt="" class="logo"/>
          <div class='text3'>
            多端全链路分期解决方案平台
          </div>

          <div class="title">
            快速登录
          </div>
          <div class="mcell">
            <div class="cell-value">
              <img src="../assets/imgs/1.png" class="ico"/>
              <input type="text" v-model="form.username" placeholder="请输入账号">
            </div>
          </div>
          <div class="mcell">
            <div class="cell-value">
              <img src="../assets/imgs/2.png" class="ico"/>
              <input type="password" v-model="form.pwd" @keyup.enter="onSubmit()" placeholder="请输入密码">
            </div>
          </div>
          <div class="submit" @click="onSubmit()">登 录</div>
        </div>
      </div>

    </div>
    <!-- <div class='foot'>
      <div class="company">@2024微开软件</div>
    </div> -->
  </div>
</template>
<script>

export default {
  data() {
    return {
      form: {
        username: '',
        pwd: ''
      },
      btnloading: true,
      rules: {
        username: [{
          required: true,
          message: '请输入账号',
          trigger: 'blur'
        }],
        pwd: [{
          required: true,
          message: '请输入密码',
          trigger: 'blur'
        }]
      },
      websock: '',
      is: false,
      setting: {
        bg: '',
        shop_bg: '',
      }
    }
  },
  mounted() {
    setTimeout(() => {
      this.is = true
    }, 2000)
  },
  created() {
    this.$apiAll.setting.getConfig().then(res => {
      Object.assign(this.setting, res.data)
    })
  },

  beforeDestroy() {
  },
  methods: {

    async onSubmit() {

      const _this = this
      if (!this.form.username) {
        this.$message.error({
          showClose: true,
          message: '请输入账号'
        })
        return
      }
      if (!this.form.pwd) {
        this.$message.error({
          showClose: true,
          message: '请输入密码'
        })
        return
      }
      let res = await this.$api.checkLogin(this.form)
      this.btnloading = false
      if (res) {
        let xinxi = res.data

        if (xinxi.status == 1) {
          this.$message.error('管理员状态不可用')
          return
        }
        let data = res.data
        let userInfo = {
          token: data.token,
          nickname: data.user_name
        }

        window.sessionStorage.setItem('admintoken', data.token)
        // window.sessionStorage.setItem('putispermission', JSON.stringify(res.data.menu_auth_list))
        // this.$store.commit('putispermission', res.data.menu_auth_list)
        window.sessionStorage.setItem('shopId', data.shop_id)
        window.sessionStorage.setItem('logo', data.logo)

        this.$api.getMyselfNav().then(res => {
          try {
            res.data.forEach(item => {
              if (item.path != '') {
                _this.$router.push(item.path)
                throw new Error('LooInterrupt')
              }
            })
          } catch (e) {
            if (e.message !== 'LooInterrupt') throw e
          }
        })
      }
    }
  }
}
</script>

<style>
.main {
  width: 100vw;
  height: 100vh;
  background: url(../assets/imgs/bg.png);
  background-size: 100% 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.head {
  width: 100%;
  height: 4vw;
  background: white;
}

.logo {
  height: 3vw;
}

.foot {
  width: 100%;
  height: 10vw;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.foot .company {
  width: 90%;
  margin-left: 5%;
  text-align: center;
  font-size: .8vw;
  color: #000;
}

.title {
  width: 80%;
  margin-left: 5%;
  color: #000;
  font-size: 22px;
  font-weight: 500;
  margin-top: 40px;
}

.mid {
  width: 100%;
  flex: 1;
  display: flex;
}

.left {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.tips {
  width: 60%;
}

.text1 {
  font-size: .28rem;
  color: white;
  font-weight: bold;
  width: 100%;
}

.text2 {
  font-size: .14rem;
  color: white;
  width: 100%;
  margin-top: 5px;
}

.right {
  width: 50vw;
  display: flex;
  align-items: center;
  justify-content: center;
}

.right .login {
  background: white;
  width: 25vw;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border-radius: 8px;
  height: 52vh;
  box-shadow: 0 0 3px 1px #d0d0d0;
}

.text3 {
  font-size: 17px;
  color: #A0A6B2;
  padding: 6px 0;
}

.ico {
  width: .1rem;
  height: .1rem;
  margin: 0 6px;
}

.mcell {
  width: 70%;
  background: #F4F8FF;
  padding: 4px 0;
  margin-top: 20px;
}

.mcell input {
  padding: 4px 0;
  text-indent: 3%;
  border-left: 1px solid #E6EBF3;
  margin-left: 5px;
  background: transparent;
  flex: 1;
  font-size: 15px;
}

.cell-name {
  font-size: .9vw;
  margin-bottom: .2vw;
  color: #333;
}

.cell-value {
  display: flex;
  align-items: center;
  padding: .3vw;
  border-radius: .3vw;
}

.submit {
  width: 70%;
  margin-top: 30px;
  background: #0C73FE;
  color: white;
  height: 40px;
  border-radius: 8px;
  font-size: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
